 class System {

    /**
     * @constructor
     * @param type {string}
     * @param total {string}
     */

    constructor(type,total) {
        this.type = type;
        this.total = total;
        this._setTitle();
    }

    /**
     * Set system title
     * @private
     */

    _setTitle() {
        this.title = this.type + '/' + this.total;
    }

}

export default  System;



// WEBPACK FOOTER //
// system.js